import { render, staticRenderFns } from "./twoTable.vue?vue&type=template&id=41d6fedd&scoped=true&"
import script from "./twoTable.vue?vue&type=script&lang=js&"
export * from "./twoTable.vue?vue&type=script&lang=js&"
import style0 from "./twoTable.vue?vue&type=style&index=0&id=41d6fedd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d6fedd",
  null
  
)

export default component.exports